/** @jsxImportSource @emotion/react */

import React from "react";
import Immutable from "immutable";

import Drawer from "js/common/views/drawer";
import ScheduleFormContent from "js/dashboards/scheduling/schedule-form-content";

const ScheduleDrawer = React.memo(
  ({
    open,
    onRequestClose,
    configId,
    idToDashboard,
    SavedConfigs,
    scheduleToEdit,
    onScheduleUpdate,
    existingSchedules = Immutable.List(),
    addNewMode = false
  }) => {
    const DRAWER_WIDTH = "80%";
    const isEditMode = !!scheduleToEdit;
    
    // Get the dashboard name for the title
    const dashboardId = scheduleToEdit?.get("dashboardId") || configId;
    const scheduleName = scheduleToEdit?.get("name") || `${idToDashboard.getIn([dashboardId, "name"])} Report`;
    const drawerTitle = isEditMode ? `Editing ${scheduleName}` : `New Scheduled Report`;

    return (
      <Drawer
        dataProductId={open ? "schedule-drawer-open" : "schedule-drawer-closed"}
        dataTestId={"schedule-drawer"}
        width={DRAWER_WIDTH}
        onRequestClose={onRequestClose}
        open={open}
        title={drawerTitle}
        showCloseButton
        disableRestoreFocus={true}
        openRight={true}
      >
        {open && (
          <ScheduleFormContent
            configId={configId}
            idToDashboard={idToDashboard}
            SavedConfigs={SavedConfigs}
            scheduleToEdit={scheduleToEdit}
            onScheduleUpdate={onScheduleUpdate}
            existingSchedules={existingSchedules}
            addNewMode={addNewMode}
            onRequestClose={onRequestClose}
          />
        )}
      </Drawer>
    );
  }
);

export default ScheduleDrawer;
